module.exports = __webpack_public_path__ + "fonts/righthand-lightdash-personal.a289c265.ttf";